/**
 * Composition hook - combines all product hooks into a single state
 * This is the ONLY hook the thin provider calls (Algolia pattern)
 * React Compiler handles memoization - no manual useMemo needed
 */
import { useProductActions } from './useProductActions'
import { useProductData } from './useProductData'
import { getProductViewConfig } from '../../lib/productViewConfig'

import type { ProductAttributeContextValue } from '../../types'

export function useProductState(productSku: string): ProductAttributeContextValue {
  const {
    productDescription,
    productAttributes,
    productRelated,
    autoRelatedProducts,
    rewardPoints,
    loadingAttributes,
    loadingDescription,
    loadingRelated,
    loadingAutoRelated,
    loadingRewardPoints,
    errors,
  } = useProductData(productSku)

  const {
    appConfig,
    productInfoConfig,
    configAttachments,
    tbiConfig,
  } = getProductViewConfig()

  const {
    productName,
    description,
    customAttributes,
    categories,
    upsellProducts,
    relatedProducts,
    crossSellProducts,
    autoRelatedProducts: derivedAutoRelated,
    rewardPoints: derivedRewardPoints,
    averageStars,
    numberOfReviews,
  } = useProductActions({
    productAttributes,
    productDescription,
    productRelated,
    autoRelatedProducts,
    rewardPoints,
  })

  return {
    productSku,
    productDescription,
    productAttributes,
    productRelated,
    loadingAttributes,
    loadingDescription,
    loadingRelated,
    loadingAutoRelated,
    loadingRewardPoints,
    loading: loadingAttributes,
    error: errors[0] ?? null,
    appConfig,
    configAttachments,
    productInfoConfig,
    upsellProducts,
    relatedProducts,
    crossSellProducts,
    autoRelatedProducts: derivedAutoRelated,
    productName,
    description,
    customAttributes,
    categories,
    tbiConfig,
    rewardPoints: derivedRewardPoints,
    averageStars,
    numberOfReviews,
  }
}
